import { render, staticRenderFns } from "./SearcherMaterialShowCategories.vue?vue&type=template&id=3c5dbac4&scoped=true&"
import script from "./SearcherMaterialShowCategories.vue?vue&type=script&lang=js&"
export * from "./SearcherMaterialShowCategories.vue?vue&type=script&lang=js&"
import style0 from "./SearcherMaterialShowCategories.vue?vue&type=style&index=0&id=3c5dbac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5dbac4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VAutocomplete,VChip,VIcon,VMenu,VSheet,VTreeview})
